export function registerAppServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  const publicUrl = new URL(`${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/`, window.location.origin);
  if (publicUrl.origin !== window.location.origin) return;
  const scriptUrl = new URL('service-worker.js', publicUrl);

  if (process.env.NODE_ENV !== 'production') {
    // Development must not remove unrelated apps' workers on the same origin.
    navigator.serviceWorker.getRegistrations?.().then((registrations) => {
      registrations.filter((registration) => registration.scope === publicUrl.href &&
        [registration.active, registration.waiting, registration.installing].some((worker) =>
          worker && new URL(worker.scriptURL).pathname === scriptUrl.pathname
        )).forEach((registration) => registration.unregister());
    }).catch(() => {});
    return;
  }

  const register = () => {
    scriptUrl.searchParams.set('release', process.env.REACT_APP_RELEASE_ID || 'local');
    navigator.serviceWorker.register(scriptUrl.href, { updateViaCache: 'none' }).then((registration) => {
      let lastUpdateCheck = Date.now();
      // Installed apps may remain open for days; check when the user returns, without polling.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible' || navigator.onLine === false ||
            Date.now() - lastUpdateCheck < 15 * 60 * 1000) return;
        lastUpdateCheck = Date.now();
        registration.update().catch(() => {});
      });
    }).catch(() => {});
  };
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
